export default "__VITE_ASSET__BsPMxnGO__"